@import '../general';
@import 'header';

:host {
  display: block;
}
